import React from "react";
import { useParams } from "react-router-dom";
import { Stack } from "react-bootstrap";
import BranchTypeBadge from "@/components/ui/branchTypeBadge";
import { useGetInfoBranchForCategoriesPageQuery } from "@/graphql/categories/categories.hooks";
import SpinnerCustom from "@/components/ui/spinner";
import { getMenuTypeFromUrl } from "@/components/cart/helpers/cartEvents";

interface BranchInfoHeaderProps {
  classes?: string;
  titleClasses?: string;
}

const BranchInfoHeader: React.FC<BranchInfoHeaderProps> = ({
  classes,
  titleClasses = "fs-32 me-2",
}) => {
  const { menuId, branchId, typeMenu } = useParams();
  const menuTypeEnum = getMenuTypeFromUrl(typeMenu);
  const hasMenuId = Boolean(menuId);

  const { data: infoBranchData, loading: infoBranchLoading } =
    useGetInfoBranchForCategoriesPageQuery({
      variables: {
        menuId: Number(menuId),
        branchId: Number(branchId),
        typeMenu: hasMenuId ? null : menuTypeEnum,
      },
      skip: !branchId || !menuTypeEnum,
    });

  const infoBranch = infoBranchData?.menu?.branch;

  if (infoBranchLoading) return <SpinnerCustom />;

  return (
    <>
      <Stack direction="horizontal" className={`${classes} align-middle`}>
        <h2 className={`m-0 ${titleClasses}`}>{infoBranch?.name}</h2>
        <BranchTypeBadge>{infoBranch?.type?.name}</BranchTypeBadge>
      </Stack>
    </>
  );
};

export default BranchInfoHeader;
